import {m} from '@codeurs/front'
import {Component} from 'react'
import loadScript from 'simple-load-script'

const currentUrl = () => location.pathname + location.search

export class Tracker extends Component<{
	children: (api?: {url: string; title: string}) => void
}> {
	url: string
	render() {
		const current = currentUrl()
		if (current === this.url) return
		this.props.children({url: (this.url = current), title: document.title})
		return null
	}
}

declare global {
	interface Window {
		gtag: (...args: Array<any>) => void
		dataLayer: Array<any>
		_mtm: any[]
	}
}
declare var gtag: (...args: Array<any>) => void
declare var dataLayer: Array<any>

export class GATracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	constructor(props) {
		super(props)
		const {id, acceptedCookies} = this.props
		loadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`).catch(
			error => {
				console.log(error)
			}
		)
		window.dataLayer = window.dataLayer || []
		window.gtag = function () {
			window.dataLayer.push(arguments)
		}
		gtag('js', new Date())
		gtag('config', id, {anonymize_ip: !acceptedCookies})
	}

	render() {
		const {acceptedCookies} = this.props
		return (
			<Tracker>
				{({url, title}) =>
					gtag('event', 'page_view', {
						page_path: url,
						page_title: title,
						anonymize_ip: !acceptedCookies
					})
				}
			</Tracker>
		)
	}
}

export class GTMTracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	constructor(props) {
		super(props)
		const {id} = this.props
		loadScript(
			`https://www.googletagmanager.com/gtm.js?id=${id}&l=dataLayer`
		).catch(error => {
			console.log(error)
		})
		window.dataLayer = window.dataLayer || []
		dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js'
		})
	}
	previousTitle = null
	render() {
		const {acceptedCookies} = this.props
		if (document.title === this.previousTitle) {
			return null
		} else {
			this.previousTitle = document.title

			return (
				<Tracker>
					{({url}) =>
						dataLayer.push({
							event: 'VirtualPageview',
							virtualPageURL: url,
							virtualPageTitle: document.title,
							anonymize_ip: !acceptedCookies
						})
					}
				</Tracker>
			)
		}
	}
}

export class MTMTracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	constructor(props) {
		super(props)
		const {id} = this.props
		loadScript(`https://analytics.klimaat.be/js/container_${id}.js`).catch(
			console.error
		)
		window._mtm = window._mtm || []
		window._mtm.push({
			'mtm.startTime': new Date().getTime(),
			event: 'mtm.Start'
		})
	}

	render() {
		return (
			<Tracker>{({url}) => window._mtm.push({event: 'mtm.PageView'})}</Tracker>
		)
	}
}

declare global {
	interface Window {
		fbq: any
	}
}
declare var fbq: any

export class FBPTracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	loaded = false
	render() {
		const {id, acceptedCookies} = this.props
		if (this.loaded || !acceptedCookies) return
		this.loaded = true
		loadScript('https://connect.facebook.net/en_US/fbevents.js').catch(
			error => {
				console.log(error)
			}
		)
		window.fbq = function () {
			fbq.callMethod
				? fbq.callMethod.apply(fbq, arguments)
				: fbq.queue.push(arguments)
		}
		fbq.loaded = true
		fbq.version = '2.0'
		fbq.queue = []
		fbq('init', id)
		fbq('track', 'PageView')
		return null
	}
}
